import { motion } from "framer-motion";
import { Reveal } from "@/components/motion/Reveal";
import { Rich } from "@/components/common/Rich";

// Numbered horizontal process; the connecting line draws as it scrolls into view.
export const StepFlow = ({ steps = [] }) => (
  <ol className="relative grid gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8" data-testid="step-flow">
    <motion.span
      aria-hidden="true"
      className="absolute left-0 right-0 top-6 hidden h-px origin-left bg-accent lg:block"
      initial={{ scaleX: 0 }}
      whileInView={{ scaleX: 1 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
    />
    {steps.map((s, i) => (
      <Reveal as="li" key={s.title} delay={0.15 + i * 0.12} className="relative" data-testid={`step-${i + 1}`}>
        <span className="relative z-10 grid h-12 w-12 place-items-center border border-accent bg-paper font-mono text-[13px] text-accent">
          {String(i + 1).padStart(2, "0")}
        </span>
        <h3 className="mt-7 font-display text-2xl font-semibold tracking-[-0.025em] text-ink">{s.title}</h3>
        <p className="mt-3 text-[15px] leading-relaxed text-muted">
          <Rich text={s.body} />
        </p>
      </Reveal>
    ))}
  </ol>
);
